export default {
  congratulations: "Congratulations!",
  gifterEmailError: "Your email must be a valid email",
  headerTextFirst: "Give a Gift Subscription to",
  headerTextLast: "The perfect gift for the fellow fans in your life!",
  recipientEmailError: "Recipient's email must be a valid email",
  redeemGift: "Redeem Gift",
  redeemHeaderText: "Redeem your gift subscription to",
  required: "Required",
  toSite: (siteName: string): string => `${siteName.replace(".com", "")}`,
  youHaveBeenGiftedASub: (
    siteName: string,
    duration: string,
    durationUnit: string
  ): string => {
    const plural = duration === "1" ? "" : "s";
    return `You have been gifted a subscription to ${siteName.replace(
      ".com",
      ""
    )}. Enjoy your gift subscription for ${duration} ${durationUnit}${plural}.`;
  }
};
